export default Object.freeze({
  SEARCH: 'search',
  RESOURCES: 'resources',
  RENEWAL_CALC: 'renewal calculator',
  CART: 'cart',
  CREATE_ACCOUNT: 'create account',
  LOG_IN: 'log in',
});